// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
import Component from 'core/entities/components/Component';


/**
 * The configuration object for the DialogueComponent.
 * @typedef {Object} DialogueConfig
 * @property {string} name
 * @property {string} alias
 */

/**
 * The Dialogue Component.
 * Adds Lex voice-to-text and chatbot functionality to an entity.
 * @property {string} type
 * @property {string} name
 * @property {string} alias
 */
class DialogueComponent extends Component {
  constructor() {
    super();
    this.type = 'DialogueComponent';
  }

  /**
   * Updates the component values according to a config.
   *
   * @param {DialogueConfig} config
   */
  updateConfig(config) {
    if (config.name) {
      this.name = config.name;
    }
    if (config.alias) {
      this.alias = config.alias;
    }
  }
}

export default DialogueComponent;
